// auth.js
export const LOGOUT = 'LOGOUT';
export const SAVE_TOKEN = 'SAVE_TOKEN';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const FETCH_PARAMS_SUCCESS = 'FETCH_PARAMS_SUCCESS';
export const FETCH_PARAMS_FAILURE = 'FETCH_PARAMS_FAILURE';
export const UPDATE_USER = 'UPDATE_USER';

// lang.js
export const SET_LOCALE = 'SET_LOCALE';

// sidebar.js
export const SET_SIDEBAR_VISIBLE = 'SET_SIDEBAR_VISIBLE';
export const SET_SIDEBAR_MINI = 'SET_SIDEBAR_MINI';
export const SET_COUNT_NOTIFY = 'SET_COUNT_NOTIFY';
export const MINUS_COUNT_NOTIFY = 'MINUS_COUNT_NOTIFY';

// notifications.js
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';

// profile.js
export const SET_CURRENT_ENTERPRISE = 'SET_CURRENT_ENTERPRISE';
export const RESET_ENTERPRISE = 'RESET_ENTERPRISE';

// window.js
export const SET_WIDTH = 'SET_WIDTH';

// theme.js
export const SET_THEME_COLOR = 'SET_THEME_COLOR';
